export const FLOAT_API_URL = 'https://api.float.com/v3'
export const API_URL = process.env.REACT_APP_SAUCE_URL
export const SAUCE_API_URL = API_URL
export const SAUCE_API_VERSION = process.env.REACT_APP_SAUCE_VERSION
export const PROJECT_ROLLUP_DELIMITER = '::'
export const HOURS_PER_DAY = 8
export const APP_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT



// WEBPACK FOOTER //
// ./src/config.js